<template>
  <div class="app">
    <nav class="navbar">
      <div class="navbar-brand">
        <img src="../public/helmet.png" alt="LLyon Logo" class="logo">
        <router-link to="/" class="brand-name">LLyon Engenharia</router-link>
      </div>
      <div class="navbar-menu">
        <router-link to="/">Início</router-link>
        <router-link to="/sobre">Sobre</router-link>
        <router-link to="/servicos">Serviços</router-link>
        <router-link to="/contato">Contato</router-link>
      </div>
    </nav>

    <router-view></router-view>

    <footer class="footer">
      <div class="footer-content">
        <div class="footer-section">
          <h3>LLyon Engenharia</h3>
          <p>Serviços de Engenharia com experiência e qualidade</p>
        </div>
        <div class="footer-section">
          <h3>Contato</h3>
          <p><i class="fas fa-envelope"></i> llyonengenharia@gmail.com</p>
          <p><i class="fab fa-instagram"></i> @llyonengenharia</p>
          <p><i class="fab fa-whatsapp"></i> (11) 95745-0292</p>
        </div>
      </div>
      <div class="footer-bottom">
        <p>&copy; 2025 LLyon Engenharia. Todos os direitos reservados.</p>
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: 'App'
}
</script>

<style lang="scss">
:root {
  --primary-color: #2c3e50;
  --secondary-color: #3498db;
  --accent-color: #e74c3c;
  --text-color: #333;
  --light-bg: #f8f9fa;
}

* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

body {
  font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
  line-height: 1.6;
  color: var(--text-color);
}

.app {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

.navbar {
  background-color: var(--primary-color);
  padding: 1rem 2rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  position: fixed;
  width: 100%;
  top: 0;
  z-index: 1000;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);

  .navbar-brand {
    display: flex;
    align-items: center;

    .logo {
      height: 40px;
      margin-right: 1rem;
    }

    .brand-name {
      color: white;
      text-decoration: none;
      font-weight: 500;
      transition: color 0.3s ease;

      &:hover {
        color: var(--secondary-color);
      }
    }
  }

  .navbar-menu {
    display: flex;
    gap: 2rem;

    a {
      color: white;
      text-decoration: none;
      font-weight: 500;
      transition: color 0.3s ease;

      &:hover {
        color: var(--secondary-color);
      }

      &.router-link-active {
        color: var(--secondary-color);
      }
    }
  }
}

.footer {
  background-color: var(--primary-color);
  color: white;
  padding: 3rem 2rem 1rem;
  margin-top: auto;

  .footer-content {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
    gap: 2rem;
    max-width: 1200px;
    margin: 0 auto;
  }

  .footer-section {
    h3 {
      margin-bottom: 1rem;
      color: var(--secondary-color);
    }

    p {
      margin-bottom: 0.5rem;

      i {
        margin-right: 0.5rem;
        color: var(--secondary-color);
      }
    }
  }

  .footer-bottom {
    text-align: center;
    margin-top: 2rem;
    padding-top: 1rem;
    border-top: 1px solid rgba(255, 255, 255, 0.1);
  }
}

@media (max-width: 768px) {
  .navbar {
    flex-direction: column;
    padding: 1rem;

    .navbar-menu {
      margin-top: 1rem;
      gap: 1rem;
    }
  }
}
</style>